export enum CurveType {
    TorqueOverSpeed,
    TorqueOverSpeedWithSpecificVoltage,
    Load,
    LimitCurve,
    AccelerationTorque,
    AccelerationTorqueWithSpecificVoltage,
    CurrentOverSpeed,
    CurrentOverSpeedWithSpecificVoltage,
    DolStarDeltaTorque,
    DolStarDeltaCurrent,
    LoadPower,
    MotorShaftPower,
    MotorShaftPowerWithSpecificVoltage,
    StartUpTime,
    StartUpTimeWithSpecificVoltage,
    StartUpTimeWithYD,
    CurrentOverTimeWithY,
    CurrentOverTimeWithYWithSpecificVoltage,
    CurrentOverTimeWithD,
    CurrentOverTimeWithDWithSpecificVoltage,
    CurrentOverTimeWithYD,
    CurrentOverPower,
    SpeedOverPower,
    PowerFactorOverPower,
    EfficiencyOverPower,
    VsdTorqueLimit,
    VsdPowerLimit
}
